import DataService from "../dataService";
import api from "../api";

const getPhotoGallery = async () => {
    try {
        const response = await DataService.get(`${api.PhotoGalleyApi}`);
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error?.message || 'An error occurred while fetching Photo Gallery';
    }
};

const getVideoGallery = async () => {
    try {
        const response = await DataService.get(`${api.VideoGalleyApi}`);
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error?.message || 'An error occurred while fetching Video Gallery';
    }
};

const getMediaGallery = async () => {
    try {
        const response = await DataService.get(`${api.MediaGalleyApi}`);
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error?.message || 'An error occurred while fetching Media Gallery';
    }
};

export {
    getPhotoGallery,
    getVideoGallery,
    getMediaGallery
}

